import Types from './types'

export const setUpdateAllMetricsDismissed = (dismissed) => ({
  type: Types.SET_UPDATE_ALL_METRICS_DISMISSED,
  payload: dismissed,
})
